import * as Sentry from '@sentry/react'

const env = import.meta.env

export const API_BASE_URL =
  env.VITE_API_BASE_URL || (typeof window !== 'undefined' && window.location.origin)

if (env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}
// NEW: Centralized support portal URL
export const SUPPORT_PORTAL_URL =
  env.VITE_SUPPORT_PORTAL_URL || 'https://polygran.atlassian.net/servicedesk/customer/portal/143'
